import React from 'react';
import { FiArrowLeft, FiMenu } from 'react-icons/fi';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setSidebarVisible } from '../../../../support/store/SidebarReducer';
import './styles.css';

function useHeader() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const handleMenu = () => {
    dispatch(setSidebarVisible({ visible: true }));
  };

  const handleGoBack = () => (location.state?.nextPath ? history.push(location.state.nextPath) : history.goBack());

  return ({
    localStates: {

    },
    eventHandlers: {
      handleMenu,
      handleGoBack,
    },
  });
}

export default function Header(props) {
  const { remoteStates, metaStates } = props;
  const { eventHandlers } = useHeader();

  return (
    <div className="header-container" style={{ boxShadow: 'none' }}>
      <section className="navigation-container">
        <FiArrowLeft onClick={eventHandlers.handleGoBack} className="touchable-icon" size={32} color="#000" />

        <p style={{ fontSize: 18, fontWeight: 200 }}>
          {(metaStates?.isLoading || metaStates?.isIdle) ? 'Carregando...' : `Dados de ${remoteStates?.user?.firstName} ${remoteStates?.user?.lastName}`}
        </p>

        <FiMenu onClick={eventHandlers.handleMenu} size={32} color="#000" className="share-icon" />
      </section>
    </div>
  );
}
